module.exports = __webpack_public_path__ + "img/data-server-6.e070804.png";